import IconSocialMediaYoutube from './IconSocialMediaYoutube';

export default IconSocialMediaYoutube;
